import React from 'react';
import Icon from '../../../components/AppIcon';

const AssessmentProgress = ({ currentStep, totalSteps, completedSteps }) => {
  const progressPercentage = (completedSteps / totalSteps) * 100;

  return (
    <div className="bg-white rounded-lg shadow-brand-subtle p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary">Assessment Progress</h3>
        <span className="text-sm text-text-secondary font-mono">
          {completedSteps}/{totalSteps} Complete
        </span>
      </div>
      
      <div className="relative">
        <div className="w-full bg-muted rounded-full h-3 mb-4">
          <div 
            className="timeline-progress h-3 rounded-full transition-all duration-800"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        <div className="flex justify-between text-xs text-text-secondary">
          <span>Network Overview</span>
          <span>Infrastructure Details</span>
          <span>Performance Requirements</span>
          <span>Future Planning</span>
          <span>Results</span>
        </div>
      </div>
      
      <div className="flex items-center mt-4 p-3 bg-surface rounded-lg">
        <Icon name="Info" size={16} className="text-primary mr-2" />
        <p className="text-sm text-text-secondary">
          Step {currentStep}: This assessment typically takes 8-12 minutes to complete
        </p>
      </div>
    </div>
  );
};

export default AssessmentProgress;